import React from 'react'
import PropTypes from 'prop-types'
import Avatar from 'common/components/Avatar'
import LevelSelect from '../AccessSelect/AccessSelect'
import { StyledFormElement as FormElement } from '../../common/FormElement'
import Text from 'common/components/Text'
import ShareRow from '../ShareRow'
import User from 'common/components/User'

export const ShareUser = ({ share, submitForm, userId, t, editable }) => {
  if (!share.user) {
    console.warn('Invalid share', share, userId)
    return null
  }
  return (
    <ShareRow>
      {share.user.id ? (
        <User userId={share.user.id} />
      ) : (
        <Avatar name={share.user.email} />
      )}

      <Text grey>{share.user.email}</Text>
      {!share.dateAccepted && <Text grey>{t('share.pending')}</Text>}
      <FormElement.Spacer />
      {editable && share.user.id !== userId ? (
        <LevelSelect
          remove="remove"
          onChange={submitForm}
          inherited={share.inheritedAccessLevel}
        />
      ) : (
        <Text grey>{t('share.accessDescription.' + share.accessLevel)}</Text>
      )}
    </ShareRow>
  )
}

ShareUser.propTypes = {
  share: PropTypes.shape({
    user: PropTypes.shape({
      displayName: PropTypes.string,
      id: PropTypes.string,
      email: PropTypes.string
    }),
    dateAccepted: PropTypes.number,
    accessLevel: PropTypes.number.isRequired
  }).isRequired,
  submitForm: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired
}

export default ShareUser
